// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PhotoGallery_wrapper__2gsic","photosList":"PhotoGallery_photosList__3JD8V","photoDetail":"PhotoGallery_photoDetail__2CsS8"};